/**
 * 商品メイン画像の左右矢印をPCで機能させる
 *
 * 【背景】
 * サムネイル系のデスクトップレイアウトでは、メイン画像リストの
 * アクティブ以外の項目が CSS で display:none になる。その結果
 * scrollWidth === clientWidth となり、スクロールで送る Dawn 標準の
 * 矢印（slider-component）が何も起こせない状態になっていた。
 *
 * 【対応】
 * リストがスクロール不能なときに限り、矢印クリックを横取りして
 * media-gallery の setActiveMedia() で前後の画像に切り替える。
 * スクロール可能なとき（モバイル等）は Dawn 標準の動作をそのまま使う。
 *
 * Dawn 本体（media-gallery.js / global.js）は改変しない。
 * テーマ更新時の競合を避けるため、この機能は本ファイルで完結させている。
 *
 * 依存: media-gallery.js（setActiveMedia）, constants.js / pubsub.js（任意）
 */
(function () {
  const VIEWER_ID_PREFIX = 'GalleryViewer';
  // 端数による誤判定を避けるための許容値
  const SCROLL_TOLERANCE = 1;

  /** メイン画像リストが横スクロール可能か（＝Dawn標準の矢印が機能するか） */
  function isScrollable(list) {
    return !!list && list.scrollWidth > list.clientWidth + SCROLL_TOLERANCE;
  }

  /** ボタンから対象のギャラリー要素一式を取り出す。対象外なら null */
  function resolveParts(button) {
    const sliderComponent = button.closest('slider-component');
    // サムネイル列のスライダーではなく、メイン画像ビューアのボタンだけを扱う
    if (!sliderComponent || sliderComponent.id.indexOf(VIEWER_ID_PREFIX) !== 0) return null;

    const gallery = button.closest('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return null;

    const list = sliderComponent.querySelector('.product__media-list');
    const items = Array.from(sliderComponent.querySelectorAll('.product__media-item[data-media-id]'));
    if (!list || items.length < 2) return null;

    return { gallery, sliderComponent, list, items };
  }

  /** 先頭/末尾で矢印を無効化する（スクロールが起きないため Dawn 側では更新されない） */
  function syncDisabledState(sliderComponent, items, index) {
    const prev = sliderComponent.querySelector('.slider-button--prev');
    const next = sliderComponent.querySelector('.slider-button--next');
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= items.length - 1;
  }

  function onClickCapture(event) {
    const button = event.target.closest('.slider-button');
    if (!button) return;

    const parts = resolveParts(button);
    if (!parts) return;

    // スクロールで送れる状況では Dawn 標準の挙動に任せる
    if (isScrollable(parts.list)) return;

    const currentIndex = parts.items.findIndex((item) => item.classList.contains('is-active'));
    const step = button.name === 'next' ? 1 : -1;
    const nextIndex = (currentIndex === -1 ? 0 : currentIndex) + step;
    if (nextIndex < 0 || nextIndex >= parts.items.length) return;

    // Dawn 標準のスクロール処理を走らせない
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    parts.gallery.setActiveMedia(parts.items[nextIndex].dataset.mediaId, false);
    syncDisabledState(parts.sliderComponent, parts.items, nextIndex);
  }

  /** 全ギャラリーの矢印の活性状態を現在のアクティブ画像に合わせる */
  function syncAll() {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      const sliderComponent = gallery.querySelector(`[id^="${VIEWER_ID_PREFIX}"]`);
      if (!sliderComponent) return;

      const list = sliderComponent.querySelector('.product__media-list');
      if (isScrollable(list)) return;

      const items = Array.from(sliderComponent.querySelectorAll('.product__media-item[data-media-id]'));
      if (items.length < 2) return;

      const index = items.findIndex((item) => item.classList.contains('is-active'));
      syncDisabledState(sliderComponent, items, index === -1 ? 0 : index);
    });
  }

  document.addEventListener('click', onClickCapture, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  // バリアント変更で product-info ごと差し替わるため、描画後に再同期する
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      window.setTimeout(syncAll, 0);
    });
  }

  // 画面幅の変更でスクロール可否が変わるため追従する
  window.addEventListener('resize', syncAll);
})();
